import { render, staticRenderFns } from "./CategoryActions.vue?vue&type=template&id=4e380d8a&"
import script from "./CategoryActions.vue?vue&type=script&lang=js&"
export * from "./CategoryActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports